import { defineComponent as m, ref as f, h as s, mergeProps as o } from "vue";
import { useMergedClsPrefix as a } from "./ghl-ui.es854.js";
import d, { ellipsisProps as u, createLineClampClass as c, createCursorClass as g } from "./ghl-ui.es413.js";
import C from "./ghl-ui.es1005.js";
import h from "./ghl-ui.es908.js";
const y = m({
  name: "PerformantEllipsis",
  props: u,
  inheritAttrs: !1,
  setup(i, {
    attrs: p,
    slots: t
  }) {
    const n = f(!1), l = a();
    return h("-ellipsis", C, l), {
      mouseEntered: n,
      renderTrigger: () => {
        const {
          lineClamp: e
        } = i, r = l.value;
        return s("span", Object.assign({}, o(p, {
          class: [`${r}-ellipsis`, e !== void 0 ? c(r) : void 0, i.expandTrigger === "click" ? g(r, "pointer") : void 0],
          style: e === void 0 ? {
            textOverflow: "ellipsis"
          } : {
            "-webkit-line-clamp": e
          }
        }), {
          onMouseenter: () => {
            n.value = !0;
          }
        }), e ? t : s("span", null, t));
      }
    };
  },
  render() {
    return this.mouseEntered ? s(d, o({}, this.$attrs, this.$props), this.$slots) : this.renderTrigger();
  }
});
export {
  y as NPerformantEllipsis
};
